import { render } from "./LocationTypeDistribution.vue?vue&type=template&id=112f3760"
import script from "./LocationTypeDistribution.vue?vue&type=script&lang=js"
export * from "./LocationTypeDistribution.vue?vue&type=script&lang=js"
script.render = render

export default script